let currentPage = 1
let totalPages = null

export default {
  init () {
    let that = this;
    // counter used for paginating correctly
    window.categoryPageLoaderCounter = 1;
    let defaultCategory = $('.cat-filter-nav .active').data('slug')
    that.getData(1, defaultCategory);
    that.filterBySlug();
    that.loadMoreHandler();
    that.setArrowPosition();
    that.initSelectFilter();

    window.addEventListener('resize', function () {
      that.setArrowPosition();
    });
  },

  filterBySlug () {
    $('.js-filter-by-category').on('click', (el) => {
      // loading posts is false here because we're tapping into a different category.
      window.isLoadingMorePosts = false;
      let catSlug = $(el.target).data('slug');
      this.handleActiveClass(el, catSlug)
      this.getData(1, catSlug)
      window.currentCategoryFilter = catSlug;
      window.categoryPageLoaderCounter = 1;
    });

    $('#all-link').on('click', (el) => {
      this.getData(1)
      this.handleActiveClass(el)
    });
  },

  handleActiveClass (el, slug = null) {
    $('.cat-filter-nav li').each((idx, el) => {
      $(el).find('a').removeClass('active')
    });
    $(el.currentTarget).addClass('active');
    this.setArrowPosition();

    slug = slug || 'all';
    $('.filter-select select option[value="'+slug+'"]').attr('selected', 'selected')
  },

  setArrowPosition () {
    let elWidth = $('.cat-filter-nav .active').width();
    let elPosition = $('.cat-filter-nav .active').position()?.left
    let arrowWidth = $('.filter-arrow').width()
    let position = ((elWidth - arrowWidth) / 2) + elPosition
    $('.filter-arrow').css({ 'transform': 'translateX(' +position + 'px)' })
  },

  initSelectFilter () {
    let that = this

    $('.filter-select select').on('change', function () {
      let val = $(this).val()
      $(this).blur()

      $('.cat-filter-nav .active').removeClass('active')
      if (val === 'all') {
        $('#all-link').addClass('active')
      } else {
        $('.cat-filter-nav [data-slug="'+val+'"]').addClass('active')
      }

      that.setArrowPosition()

      window.isLoadingMorePosts = false;
      if (val === 'all') {
        that.getData(1)
      } else {
        that.getData(1, val);
        window.currentCategoryFilter = val;
        window.categoryPageLoaderCounter = 1;
      }
    });
  },

  loadMoreHandler () {
    $('.articles-loadMore button').on('click', (event) => {
      $(event.currentTarget).addClass('hover:bg-mango-tango bg-opacity-50 hover:bg-opacity-50 cursor-not-allowed')
      $('.articles-loadMore button').removeClass('hover:bg-blue-prussian')
      $(event.currentTarget).prop('disabled', true)
      $(event.currentTarget).html(`
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg> Load More
      `)
      window.isLoadingMorePosts = true;
      this.getData(++window.categoryPageLoaderCounter, window.currentCategoryFilter)
    });
  },

  getData (page_num, taxonomy) {
    let that = this

    $.ajax({
      type: 'GET',
      url: '/wp-json/api/v1/articles',
      data: {
        page: page_num,
        taxonomy: taxonomy,
      },
      beforeSend: function () {
        // Only if we're not loading more posts we will clear the article's list container.
        if (!window.isLoadingMorePosts) {
          $('#articles-list').html('')
          $('#articles-loader').addClass('flex')
          $('#articles-loader').removeClass('hidden')
          $('#articles-empty').addClass('hidden')
          $('#articles-empty').removeClass('flex')
          $('.articles-loadMore').addClass('hidden')
        }
      },
      success: function (data) {
        currentPage = parseInt(data.current_page)
        totalPages = parseInt(data.total_pages)

        // handle when to show the loadmore button.
        if ((totalPages > 1) && (totalPages > currentPage)) {
          $('.articles-loadMore').removeClass('hidden')
        }

        // Handles when to show the empty message when querying.
        if (data.data.length === 0) {
          $('#articles-empty').removeClass('hidden')
          $('#articles-empty').addClass('flex')
        } else {
          $('#articles-empty').addClass('hidden')
          $('#articles-empty').removeClass('flex')
          that.drawHtml(data.data)
          window.initLazyLoad.update();
        }

        // Hide the load more button if the results only contain one page.
        if (currentPage === totalPages) {
          $('.articles-loadMore').addClass('hidden')
        }
      },

      complete: function () {
        $('.articles-loadMore button').html('Load More')
        $('.articles-loadMore button').addClass('hover:bg-blue-prussian')
        $('.articles-loadMore button').removeClass('hover:bg-mango-tango bg-opacity-50 hover:bg-opacity-50 cursor-not-allowed')
        $('.articles-loadMore button').prop('disabled', false)

        if (!window.isLoadingMorePosts) {
          $('#articles-loader').addClass('hidden')
          $('#articles-loader').removeClass('flex')
        }
      },
    })
  },

  drawHtml (data) {
    const scrollTop = $(window).scrollTop();

    $.each(data, function (idx, item) {
      let thumbnail = item.thumbnail !== null ? item.thumbnail : '/app/themes/aptim/public/images/no-image.png';
      let categories = item.categories ? item.categories.map(v => v.name) : []

      $('#articles-list').append(`
        <div id="article-${item.id}" class="article-item flex flex-col md:flex-row md:min-h-[21rem] shadow-md bg-white">
          <div class="w-full md:w-80 min-h-[21rem] flex-shrink-0 relative">
            <img data-src="${thumbnail}" alt="${item.title}" class="lazy w-full h-full object-cover object-center" />
            <span class="white-arrow-pointing-left"></span>
          </div>

          <div class="flex flex-col justify-between flex-shrink">
            <div class="
              content-wrapper
              flex flex-col h-full
              px-5 xl:px-8 2xl:px-9
              py-8 lg:py-10 2xl:py-14
            ">
              <div class="heading-area mb-5">
                <span class="text-xs text-mango-tango tracking-widest font-bold uppercase">
                  ${categories.join(', ')}
                </span>
                <span class="text-xs text-gray-shuttle tracking-widest font-bold uppercase">&nbsp; . &nbsp;</span>
                <span class="text-xs text-gray-shuttle tracking-widest font-bold uppercase">${item.date}</span>
              </div>

              <h2 class="title text-4xl text-blue-prussian font-light tracking-tight mb-3" title="${item.title}">
                ${item.title}
              </h2>

              <p class="excerpt mb-3 text-xl md:text-base" title="${item.excerpt}">
                ${item.excerpt}
              </p>

              <div>
                <a class="text-base uppercase text-blue-prussian tracking-wider font-medium mt-auto link-underlined-hover" href="${item.permalink}">Read More</a>
              </div>
            </div>
          </div>
        </div>
      `)

      $(window).scrollTop(scrollTop);
    })
  },
}
